import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'react-bootstrap';
import api from '../helpers/ApiClient';
import moment from 'moment';
import _ from 'lodash';

class EInvoiceRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Order validation fields
            orderId: '',
            internalOrderId: '',
            email: '',
            orderValidationError: null,
            orderValidated: false,
            orderValidationLoading: false,
            fulfilledItems: [],
            unfulfilledItems: [],

            // E-Invoice form fields
            invoiceType: '', // 'individual' or 'business'
            idType: '',
            idNumber: '',
            fullName: '',
            mobileNumber: '',
            emailIndividual: '',
            addressIndividual: '',
            postcodeIndividual: '',
            cityIndividual: '',
            stateIndividual: '',
            companyName: '',
            registrationNumber: '',
            emailBusiness: '',
            tin: '',
            sstRegistered: '', // 'yes' or 'no'
            sstId: '',
            addressBusiness: '',
            postcodeBusiness: '',
            cityBusiness: '',
            stateBusiness: '',

            // Form state
            error: null,
            submitted: false,
            loading: false
        };
    }

    handleInvoiceTypeChange = (event) => {
        this.setState({ invoiceType: event.target.value, error: null });
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    validateIndividualForm = () => {
        const { orderId, email, idType, idNumber, fullName, mobileNumber, emailIndividual, addressIndividual, postcodeIndividual, cityIndividual, stateIndividual } = this.state;
        if (!idType || !idNumber || !fullName || !mobileNumber || !emailIndividual || !addressIndividual || !postcodeIndividual || !cityIndividual || !stateIndividual) {
            return 'Please fill in all required fields for Individual.';
        }
        return null;
    }

    validateBusinessForm = () => {
        const { orderId, email, companyName, registrationNumber, emailBusiness, tin, sstRegistered, sstId, addressBusiness, postcodeBusiness, cityBusiness, stateBusiness, mobileNumber } = this.state;
        if (!companyName || !registrationNumber || !emailBusiness || !tin || !sstRegistered || !addressBusiness || !postcodeBusiness || !cityBusiness || !stateBusiness || !mobileNumber) {
            return 'Please fill in all required fields for Registered Business.';
        }
        if (sstRegistered === 'yes' && !sstId) {
            return 'SST ID is required when SST Registered is Yes.';
        }
        return null;
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { invoiceType } = this.state;
        let validationError = null;

        if (invoiceType === 'individual') {
            validationError = this.validateIndividualForm();
        } else if (invoiceType === 'business') {
            validationError = this.validateBusinessForm();
        } else {
            validationError = 'Please select an Invoice Type.';
        }

        if (validationError) {
            this.setState({ error: validationError });
            return;
        }

        this.setState({ loading: true, error: null });

        const {
            orderId, internalOrderId, email, idType, idNumber, fullName, mobileNumber, emailIndividual, addressIndividual, postcodeIndividual, cityIndividual, stateIndividual,
            companyName, registrationNumber, emailBusiness, tin, sstRegistered, sstId, addressBusiness, postcodeBusiness, cityBusiness, stateBusiness,
            fulfilledItems
        } = this.state;

        const data = {
            invoiceType,
            ...(invoiceType === 'individual' && {
                orderId, internalOrderId, fulfilledItems, 
                idType, idNumber, fullName, mobileNumber, email: emailIndividual, tin, 
                address: addressIndividual, postcode: postcodeIndividual, city: cityIndividual, state: stateIndividual
            }),
            ...(invoiceType === 'business' && {
                orderId, internalOrderId, fulfilledItems, 
                companyName, registrationNumber, email: emailBusiness, emailBusiness, tin, sstRegistered, sstId, mobileNumber,
                address: addressBusiness, postcode: postcodeBusiness, city: cityBusiness, state: stateBusiness
            })
        };

        return api('/api/order/einvoice-request', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(result => {
            this.setState({ loading: false, submitted: result.submitted, error: `${result.message}: ${result.details}` || null });
        }).catch(err => {
            this.setState({ loading: false, error: err.error || 'An error occurred. Please try again.' });
        });
    }

    handleOrderValidationChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleOrderValidation = (event) => {
        event.preventDefault();
        const { orderId, email } = this.state;
        if (!orderId || !email) {
            this.setState({ orderValidationError: 'Please enter both Order ID and Email.' });
            return;
        }
        this.setState({ orderValidationLoading: true, orderValidationError: null });
        // Replace with actual API endpoint for order validation
        api('/api/order/validate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderName: orderId, email })
        }).then(result => {
            if (result && result.valid) {

                //check orderId is starting with #, if not add #
                let formattedOrderId = orderId;
                if (!formattedOrderId.startsWith('#')) {
                    formattedOrderId = `#${formattedOrderId}`;
                }
                this.setState({ orderValidated: true, orderValidationLoading: false, 
                    internalOrderId: result.internalOrderId, fulfilledItems: result.fulfilled_items, 
                    unfulfilledItems: result.unfulfilled_items, orderId: formattedOrderId });
            } else {
                this.setState({ orderValidationError: result.message ? result.message : 'Invalid Order ID or Email.', orderValidationLoading: false });
            }
        }).catch(() => {
            this.setState({ orderValidationError: 'Validation failed. Please try again.', orderValidationLoading: false });
        });
    }

    renderItemSection(items, fulfilled) {
        if (items.length === 0) {
            return;
        }

        return (
            <div className="tracking-section" style={{marginBottom: '20px'}}>
                <h4 style={{marginBottom: '15px', fontWeight: '600', color: '#333'}}>
                    {fulfilled ? 'Fulfilled Items' : 'Unfulfilled Items'} <br/>
                    { !fulfilled && 
                        <small>Unfulfilled items will not be included in e-Invoice generation</small>
                    }
                </h4>
                <div className="row">
                    {_.map(items, (item, i) => {

                        return (
                            <div key={i} className="col-xs-12" style={{marginBottom: '15px'}}>
                                <div className="panel panel-default" style={{boxShadow: '0 2px 4px rgba(0,0,0,0.1)', border: '1px solid #ddd'}}>
                                    <div className="panel-body" style={{padding: '15px'}}>
                                        <div className="row">
                                            <div className="col-md-3 col-sm-4 text-center">
                                                <img 
                                                    src={item.image} 
                                                    alt={item.title} 
                                                    className="img-responsive"
                                                    style={{maxHeight: '120px', objectFit: 'cover', borderRadius: '4px'}}
                                                />
                                            </div>
                                            <div className="col-md-9 col-sm-8">
                                                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px'}}>
                                                    <h6 className="text-primary" style={{fontWeight: '600', margin: '0 0 5px 0'}}>
                                                        {item.title} - {item.variant_title}
                                                    </h6>
                                                    <span className="label label-default">x{item.quantity}</span>
                                                </div>
                                                {item.fulfilled_at && (
                                                    <p className="text-muted small" style={{marginBottom: '10px'}}>
                                                        Fulfilled on: {moment(item.fulfilled_at).format("dddd, MMMM Do YYYY")}
                                                    </p>
                                                )}
                                                <p className="text-muted small" style={{marginBottom: '10px'}}>
                                                    Price: RM{item.price}<br/>
                                                    Quantity: {item.quantity}<br/>
                                                    {item.shippingFee > 0 && (
                                                        <span>
                                                            Shipping Fee: RM{item.shippingFee.toFixed(2)}<br/>
                                                        </span>
                                                    )}
                                                    Total: RM{(item.price * item.quantity + (item.shippingFee ? item.shippingFee : 0)).toFixed(2)}<br/>
                                                </p>
                                                {
                                                    fulfilled && (
                                                        <p className="text-muted small" style={{marginBottom: '10px'}}>
                                                            Request By: {moment(item.fulfilled_at).endOf('month').add(3, 'days').format("dddd, MMMM Do YYYY")}<br/>
                                                            { moment().isAfter(moment(item.fulfilled_at).endOf('month').add(3, 'days')) ?
                                                                (<span className="text-danger">Request Date has passed</span>)
                                                                : (<span className="text-success">Request Date is upcoming</span>)
                                                            }
                                                        </p>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }

    render() {
        const {
            orderId, email, orderValidationError, orderValidated, orderValidationLoading,
            invoiceType, error, submitted, loading, fulfilledItems, unfulfilledItems
        } = this.state;

        if (submitted) {
            return (
                <div className="container" style={{padding: '20px'}}>
                    <h3>Thank you!</h3>
                    <p>Your e-invoice information has been submitted successfully.</p>
                </div>
            );
        }

        return (
            <div className="container einvoice-container">
                { !orderValidated &&
                    <h2 className="einvoice-section-title">Order Validation</h2>
                }

                { orderValidated &&
                    <h2 className="einvoice-section-title">{orderId} e-Invoice Request</h2>
                }

                {/* Order Validation Form */}
                {!orderValidated && (
                    <form onSubmit={this.handleOrderValidation} className="einvoice-validation-form">
                        {orderValidationError && <Alert bsStyle="danger">{orderValidationError}</Alert>}
                        <div className="form-group einvoice-form-group">
                            <label className="einvoice-label">Email</label>
                            <input
                                type="email"
                                name="email"
                                className="form-control einvoice-input"
                                placeholder="example@gmail.com"
                                value={email}
                                onChange={this.handleOrderValidationChange}
                                required
                            />
                        </div>
                        <div className="form-group einvoice-form-group">
                            <label className="einvoice-label">Order Number</label>
                            <input
                                type="text"
                                name="orderId"
                                className="form-control einvoice-input"
                                placeholder="#GTR12345"
                                value={orderId}
                                onChange={this.handleOrderValidationChange}
                                required
                            />
                        </div>
                        <Button
                            type="submit"
                            className="einvoice-btn-validate"
                            disabled={orderValidationLoading}
                        >
                            {orderValidationLoading ? 'Validating...' : 'Validate'}
                        </Button>
                    </form>
                )}

                {/* E-Invoice Form */}
                {orderValidated && (
                    <div>
                        <div>
                            {
                                <div >
                                    {this.renderItemSection(fulfilledItems, true)}
                                    {this.renderItemSection(unfulfilledItems, false)}
                                </div>
                            }
                        </div>

                        {fulfilledItems.length == 0 && (
                            <div className="alert alert-warning" style={{marginTop: '20px'}}>
                                <i className="fa fa-info-circle" style={{marginRight: '8px'}}></i>
                                No fulfilled items found for this order. Please ensure your order has been fulfilled before requesting an e-invoice.
                            </div>
                        )}

                        {fulfilledItems.length > 0 && (
                            <form onSubmit={this.handleSubmit} className="einvoice-validation-form" noValidate>
                                {error && <Alert bsStyle="danger">{error}</Alert>}
                                <div className="form-group einvoice-form-group">
                                    <label className="einvoice-label">Invoice Type*</label>
                                    <div>
                                        <label className="radio-inline">
                                            <input type="radio" name="invoiceType" value="individual" checked={invoiceType === 'individual'} onChange={this.handleInvoiceTypeChange} /> Individual
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="invoiceType" value="business" checked={invoiceType === 'business'} onChange={this.handleInvoiceTypeChange} /> Registered Business
                                        </label>
                                    </div>
                                </div>
                                {invoiceType === 'individual' && (
                                    <div>
                                        <hr />
                                        <h4>Individual</h4>
                                        <div className="form-group einvoice-form-group">
                                            <label className="einvoice-label">ID Type*</label>
                                            <div>
                                                <label className="radio-inline"><input type="radio" name="idType" value="NRIC" onChange={this.handleChange} checked={this.state.idType === 'NRIC'} /> My Kad</label>
                                                <label className="radio-inline"><input type="radio" name="idType" value="ARMY" onChange={this.handleChange} checked={this.state.idType === 'ARMY'} /> My Tentera</label>
                                                <label className="radio-inline"><input type="radio" name="idType" value="PASSPORT" onChange={this.handleChange} checked={this.state.idType === 'PASSPORT'} /> Passport</label>
                                            </div>
                                        </div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">ID Number*</label><input type="text" name="idNumber" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Tax ID Number (TIN)*</label><input type="text" name="tin" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Full Name*</label><input type="text" name="fullName" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Mobile Number*</label><input type="text" name="mobileNumber" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Email*</label><input type="email" name="emailIndividual" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Address*</label><input type="text" name="addressIndividual" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Postcode*</label><input type="text" name="postcodeIndividual" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">City*</label><input type="text" name="cityIndividual" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">State*</label><input type="text" name="stateIndividual" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                    </div>
                                )}
                                {invoiceType === 'business' && (
                                    <div>
                                        <hr />
                                        <h4>Registered Business</h4>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Company Name*</label><input type="text" name="companyName" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Registration Number*</label><input type="text" name="registrationNumber" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                                                                <div className="form-group einvoice-form-group"><label className="einvoice-label">Tax ID Number (TIN)*</label><input type="text" name="tin" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Email*</label><input type="email" name="emailBusiness" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Mobile Number*</label><input type="text" name="mobileNumber" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group">
                                            <label className="einvoice-label">SST Registered*</label>
                                            <div>
                                                <label className="radio-inline"><input type="radio" name="sstRegistered" value="yes" onChange={this.handleChange} checked={this.state.sstRegistered === 'yes'} /> Yes</label>
                                                <label className="radio-inline"><input type="radio" name="sstRegistered" value="no" onChange={this.handleChange} checked={this.state.sstRegistered === 'no'} /> No</label>
                                            </div>
                                        </div>
                                        {this.state.sstRegistered === 'yes' && (
                                            <div className="form-group einvoice-form-group"><label className="einvoice-label">SST ID</label><input type="text" name="sstId" className="form-control einvoice-input" onChange={this.handleChange} /></div>
                                        )}
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Address*</label><input type="text" name="addressBusiness" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">Postcode*</label><input type="text" name="postcodeBusiness" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">City*</label><input type="text" name="cityBusiness" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                        <div className="form-group einvoice-form-group"><label className="einvoice-label">State*</label><input type="text" name="stateBusiness" className="form-control einvoice-input" onChange={this.handleChange} required /></div>
                                    </div>
                                )}
                                {invoiceType && (
                                    <div>
                                        <div className="notice-section" style={{marginTop: '20px', fontSize: '12px'}}>
                                            <h4>Notice</h4>
                                            <p>By completing the details above and clicking the submit button, you acknowledge that:</p>
                                            <ol>
                                                <li>You are submitting a request for an e-Invoice as defined in the Income Tax Act 1967 and relevant Guidelines issued by the Inland Revenue Board of Malaysia ('IRBM'):</li>
                                                <li>You confirm that the fields indicated as mandatory above are completed truthfully and accurately;</li>
                                                <li>You give your consent to Helpr Asia Sdn Bhd to collect, process and share the details above with the IRBM as required under the Income Tax Act 1967 and relevant Guidelines issued by the IRBM;</li>
                                                <li>You agree not to hold Helpr Asia Sdn Bhd liable for any loss or damage suffered by you or any other party as a result of an error, omission, delay or any other matter arising from this request and/or appearing in the e-Invoice provided.</li>
                                            </ol>
                                        </div>
                                        <Button type="submit" bsStyle="primary" className="einvoice-btn-validate" disabled={loading} style={{marginTop: '15px'}}>{loading ? 'Submitting...' : 'Submit'}</Button>
                                    </div>
                                )}
                            </form>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default connect((state, props) => {
    return {};
})(EInvoiceRequest);
